import { getItem } from '@esri/arcgis-rest-portal';
export async function getPortalItemAccessPermissions({ id, authentication, }) {
    const { properties: { telemetry: { arcgis: { access = {} } = {} } = {} }, } = await getItem(id, {
        authentication,
    });
    return { access };
}
//# sourceMappingURL=get-portal-item-access-permissions.js.map